import React from 'react';

import FormGroupWrapper from '@/features/sampleDevelopment/components/SampleRequestModals/FormGroupWrapper';
import CustomDropdown from '@/components/CustomDropdown';
import InputField from '@/components/InputField';
import InputWrapper from '@/features/sampleDevelopment/components/SampleRequestModals/InputWrapper';
import { useGetFactoryListQuery } from '@/api/commonApis';
import { formatFactoryOptions, formatSampleTypeOptions } from '@/features/sampleDevelopment/utils';
import { REQUEST_FOR_FACTORY_NITEX } from '@/features/sampleDevelopment/constants';
import { checkAnyUserType, isFashionDesigner } from '@/utils/Util';

const SendToFactoryNitexDevForm = ({ handleChange, requestValues, errors, sampleTypeList }) => {
	const { data: factoryList } = useGetFactoryListQuery({ params: { page: 0, size: 1000 } });

	return (
		<React.Fragment>
			<div className="flied-item d-grid grid-columns-3 gap-3">
				<FormGroupWrapper labelTitle="Factory Name*">
					<CustomDropdown
						title="Select factory name"
						onItemClick={(value) => handleChange('factoryName', value)}
						selectedItem={requestValues?.factoryName?.name}
						items={formatFactoryOptions(factoryList)}
					/>
					{errors?.factoryName && <p className="error">{errors?.factoryName}</p>}
				</FormGroupWrapper>
				<InputWrapper labelTitle="Factory submission to Nitex*">
					<InputField
						type="date"
						name="factorySubmitionToNitexDate"
						withWrapper={false}
						withLabel={false}
						value={requestValues?.factorySubmitionToNitexDate}
						onChangeHandler={(e) => handleChange('factorySubmitionToNitexDate', e.target.value)}
						errors={errors?.factorySubmitionToNitexDate}
					/>
				</InputWrapper>
				<InputWrapper
					labelTitle={`Expected Order Date${checkAnyUserType(['ACCOUNT_MANAGER']) ? '*' : ''}`}
				>
					<InputField
						type="date"
						name="expectedOrderDate"
						withWrapper={false}
						withLabel={false}
						value={requestValues?.expectedOrderDate}
						onChangeHandler={(e) => handleChange('expectedOrderDate', e.target.value)}
						disabled={
							isFashionDesigner() ||
							checkAnyUserType(['PRODUCT_DEVELOPMENT', 'GARMENTS_TECH', 'GRAPHICS_DESIGNER'])
						}
						className={`${isFashionDesigner() ? 'cursor-none' : ''}`}
						errors={errors?.expectedOrderDate}
					/>
				</InputWrapper>
			</div>
			<div className="flied-item d-grid grid-columns-2 gap-3">
				<FormGroupWrapper labelTitle="Sample type*">
					<CustomDropdown
						title="Select Sample type"
						onItemClick={(value) => handleChange('sampleType', value)}
						selectedItem={requestValues?.sampleType?.value}
						items={formatSampleTypeOptions(sampleTypeList)}
					/>
					{errors?.sampleType && <p className="error">{errors?.sampleType}</p>}
				</FormGroupWrapper>
				<FormGroupWrapper labelTitle="Request for*">
					<CustomDropdown
						title="Select request for"
						onItemClick={(value) => handleChange('requestFor', value)}
						selectedItem={requestValues?.requestFor?.value}
						items={REQUEST_FOR_FACTORY_NITEX}
					/>
					{errors?.requestFor && <p className="error">{errors?.requestFor}</p>}
				</FormGroupWrapper>
			</div>
		</React.Fragment>
	);
};

export default SendToFactoryNitexDevForm;
